import { useState, Fragment } from "react";

import dynamic from "next/dynamic";
import Link from "next/link";
import parse from "html-react-parser";
import RecallApi from "../../../utils/external/recalls/recall";
import { RegularIcon } from "../Icons/regular";

const SEO = dynamic(() => import("../../../components/Shared/SEO"));
const ProductLayout = dynamic(() => import("../../../components/Layout/ProductLayout"));
const TableComponent = dynamic(() => import("../../../components/Shared/Builders/NewsBuilder/Table"));
const LazyLoad = dynamic(() => import("../../../components/Shared/Image/LazyLoad"));
const SmallBanner = dynamic(() => import("../../../components/Shared/Banners/SmallBanner"));
const Input = dynamic(() => import("../../../components/Shared/FormFields/Input"));

const Recall = props => {

	const { pageData, category } = props;

	const [vinNumber, setVinNumber] = useState("");
	const [getAffected, setGetAffected] = useState(false);
	const [isAffected, setIsAffected] = useState("nt");
	const [validVinNumber, setValidVinNumber] = useState(false);
	const [hasValidated, setHasValidated] = useState(false);
	const [recallMessages, setRecallMessages] = useState([]);
	const [isSuccessUserRecallApiPost, setSuccessUserRecallApiPost] = useState(false);

	const checkAffected = () => {
		if (process.env.NODE_ENV !== 'production') {
			console.log("Checking VIN number...");
		}

		if (vinNumber.length === 17) {
			setGetAffected(true);
			setValidVinNumber(true);
			setHasValidated(true);

			RecallApi.getCarsRecalls(vinNumber).then((res) => {
				setGetAffected(false);

				if (res && res.messages && res.messages.length > 0) {
					setIsAffected("yes");
					setRecallMessages(res.messages);
				} else if (res && res.error) {
					setIsAffected("no");
				} else {
					console.error('failed to request message from recalls api for vin: ' + vinNumber);
				}
			});
		} else {
			setValidVinNumber(false);
			setHasValidated(true);
		}
	};

	const getRecallForm = () => {
		switch (isAffected) {
			case "nt":
				return (
					<Fragment>
						<div className="col s12 l12">
							<div className="row">
								{category !== "Motorcycles" ?
									<div className="col s12 m12 l6 mt16px">
										<div className="row">
											<div className="col s12">
												<h4>{pageData.affectedRecall.title}</h4>
											</div>
											<div className="col s12 m12 l12">
												{pageData.recallsCardLink &&
													(
														pageData.recallsCardLink.link.type === "Entry" ?
															(
																<Link href={`/${pageData.recallsCardLink.link.uri}`}>
																	<a title={pageData.recallsCardLink.link.url}>
																		<LazyLoad image={pageData.recallsCardLink.image} />
																	</a>
																</Link>
															) : (
																<a title={pageData.recallsCardLink.link.url} href={`${pageData.recallsCardLink.link.url}`}>
																	<LazyLoad image={pageData.recallsCardLink.image} />
																</a>
															)
													)
												}
											</div>
										</div>
									</div>
									: null
								}

								<div className="col s12 m12 l6 mt16px">
									<div className="row">
										<div className="col s12">
											<h4>
												For all Vehicle Recalls on various parts,
												please enter your VIN below
											</h4>
										</div>
										<div className="col s12 m12 l12 mt16px">
											<Input
												value={vinNumber}
												onChange={setVinNumber}
												placeholder={pageData.affectedRecall.input.title}
												title={pageData.affectedRecall.input.title}
												hint={pageData.affectedRecall.input.hint}
												errorMessage="Please enter a valid 17 Digit VIN Number"
												showError={hasValidated ? !validVinNumber : ""}
											/>
										</div>
									</div>
									<div className="row">
										<div className="col s12 m12 l12">
											<button
												className="fw waves-effect waves-light hButton buttonRed"
												onClick={checkAffected}
											>
												{getAffected && <RegularIcon icon={{ icon: "spinner" }} spin />}
												{pageData.affectedRecall.input.buttonText}
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Fragment>
				);
			case "no":
				return (
					<Fragment>
						<div className="col s12">
							{pageData.affectedRecall.messages.notAffected ?
								<h4>{pageData.affectedRecall.messages.notAffected.title}</h4>
								:
								<h4>Your Honda is not affected by a recall!</h4>
							}
						</div>
						<div className="col s12 m8 l4">
							{pageData.affectedRecall.messages.notAffected ?
								<p>{pageData.affectedRecall.messages.notAffected.message}</p>
								:
								<p>Please note that information on this recall campaign is subject to change over time. As such, Honda Motor Southern Africa encourages you to revisit our website to check the status of your Honda.</p>
							}
						</div>
					</Fragment>
				);
			case "yes":
				return (
					<Fragment>
						{!isSuccessUserRecallApiPost ?
							<div>
								<div className="col s12">
									<div className="messages-container">
										{recallMessages && recallMessages.map((msg, i) => (
											<div key={i}>
												<h4 className="recall-message">{msg && msg.message && msg.message.length > 1 && (`${msg.message.charAt(0).toUpperCase()}${msg.message.slice(1)}`)}</h4>
											</div>
										))}
									</div>
									{(!recallMessages || recallMessages.length === 0) && (
										<h4>{pageData.affectedRecall.messages.affected.title}</h4>
									)}
								</div>
								<div className="col s12 m8 l4">
									{pageData.affectedRecall.messages.affected ?
										<p>{pageData.affectedRecall.messages.affected.message}</p>
										:
										<p>Please ensure you get your Honda to a dealer as soon as possible.</p>
									}
									{category === "Cars" ?
										<Link href="/cars/book-a-service">
											<a
												className="waves-effect waves-light hButton buttonRed requestAPart formBuilderSubmit"
												style={{ marginTop: "20px" }}
											>
												GET IN TOUCH WITH YOUR NEAREST DEALER
											</a>
										</Link> :
										<Link href="/motorcycles/book-a-service">
											<a
												className="waves-effect waves-light hButton buttonRed requestAPart formBuilderSubmit"
												style={{ marginTop: "20px" }}
											>
												GET IN TOUCH WITH YOUR NEAREST DEALER
											</a>
										</Link>
									}
								</div>
							</div>
							:
							<div>
								<div className="col s12">
									<h4>Your details have been submitted!</h4>
								</div>
							</div>
						}
					</Fragment>
				);
			default:
				break;
		}
	};

	const navLogo = () => {
		switch (category) {
			case "Cars":
				return pageData.nav.header.logos.cars;
			case "Motorcycles":
				return pageData.nav.header.logos.motorcycles;
			default:
				return pageData.nav.header.logos.general;
		}
	};

	return (
		<Fragment>
			<SEO seo={pageData.seo} />
			<ProductLayout nav={pageData.nav.header.links} logo={navLogo()} footer={pageData.nav.footer}>
				<SmallBanner banner={pageData.banner} />
				<div className="recall">
					<div className="customContainer">
						<div className="row recallInfo">
							<div className="col s12">
								<h2>{pageData.introTitle}</h2>
							</div>
							{pageData.introDescription && <div className="col">{parse(pageData.introDescription)}</div>}
						</div>
						<div className="row recallAffected">{getRecallForm()}</div>
						<div className="row">
							<div className="col s12">
								<h3>{pageData.contactUs.title}</h3>
							</div>
							<div className="col s12 link">
								<a href={`tel:${pageData.contactUs.number}`} title="Contact Us - Number">
									<RegularIcon
										icon={{ icon: "phone" }}
									/>
									{pageData.contactUs.number}
								</a>
							</div>
							<div className="col s12 link valign-wrapper">
								<a href={`mailto:${pageData.contactUs.email}`} title="Contact Us - Email">
									<RegularIcon
										icon={{ icon: "envelope" }}
									/>
									{pageData.contactUs.email}
								</a>
							</div>
							<div className="col mt16px s12 valign-wrapper">
								<a
									className="waves-effect waves-light hButton buttonRed btn-large whiteRedBtn"
									href={`/${category}/book-a-service`.toLowerCase()}
									title="Book a Service"
								>
									Book a service
								</a>
							</div>
						</div>
						<div className="row">
							<div className="col s12">
								<h4>{pageData.recall.title}</h4>
							</div>
						</div>
					</div>
					{pageData.recall.table.map(table => {
						return (
							<div className="col s12" key={table.id}>
								<TableComponent
									block={table.table}
									useRoot={true}
								/>
							</div>
						);
					})}
				</div>
			</ProductLayout>
		</Fragment>
	);
};

export default Recall;